import differenceBy from "lodash/differenceBy";

/**
 * Higher order function which returns a templated reducer function.
 *
 * @param {string} prefix - Action namespacing prefix, e.g. 'policies'
 * @param {string} name - Action entity name, uppercase e.g. 'SERVICES'
 * @param {object} initialState - initial state object
 */
export default function createFetchReducerWithNamedType(
  prefix = "",
  name = "",
  initialState = {}
) {
  return function reducer(state = initialState, action) {
    switch (action.type) {
      case `${prefix}/FETCH_${name}_START`:
        return {
          ...state,
          loading: true
        };
      case `${prefix}/FETCH_${name}_SUCCESS`:
        return {
          ...state,
          items: [
            ...state.items,
            ...differenceBy(action.json, state.items, "$uri")
          ],
          loading: false
        };
      case `${prefix}/FETCH_${name}_FAILED`:
        return {
          ...state,
          errorDescription: action.error.description,
          error: action.error.message,
          loading: false
        };
      default:
        return state;
    }
  };
}
